import { render } from "./PedigreeNode.vue?vue&type=template&id=54000f98&scoped=true"
import script from "./PedigreeNode.vue?vue&type=script&lang=js"
export * from "./PedigreeNode.vue?vue&type=script&lang=js"

import "./PedigreeNode.vue?vue&type=style&index=0&id=54000f98&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54000f98"]])

export default __exports__